var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"horizontal-onboard-menu",staticStyle:{"z-index":"101"}},[_c('v-app-bar',{attrs:{"color":"white","dense":""}},[_c('a',[_c('v-img',{staticStyle:{"width":"150px","margin-top":"0px"},attrs:{"src":require("@/assets/logo_color_white_text.svg")}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }